import { AppBar, Grid, Toolbar, IconButton } from "@mui/material";
import CustomText from "./CustomText";
import ImageLoader from "./ImageLoader";
import { useLocation, useNavigate } from "react-router-dom";
import MenuRedirect from "./MenuRedirect";
import { useContext } from "react";
import { ScreenContext } from "../context/ScreenContext";

const Navbar = () => {
  /**
   * Function to navigate between routes.
   * @type {Function}
   */
  const navigate = useNavigate();
  /**
   * Función que maneja la navegación a la página de inicio.
   * Utiliza la función `navigate` para redirigir al usuario a la ruta principal (`/`).
   * @function
   * @returns {void} No retorna ningún valor, solo realiza la navegación.
   */
  const handleHome = () => navigate(`/`);
  /**
   * Hook que obtiene la información sobre la ubicación actual utilizando `useLocation`.
   * @type {Location} Un objeto que contiene detalles sobre la ubicación actual, como el `pathname`.
   */
  const location = useLocation();
  /**
   * Determina si la página actual debe estar deshabilitada.
   * Esta variable evalúa si el `pathname` de la ubicación actual corresponde a las rutas "/login" o "/404".
   * Si es uno de esos valores, `disable` será `true`, de lo contrario, será `false`.
   * @type {boolean} `true` si la página actual es "/login" o "/404", `false` en otro caso.
   */
  const locationes = [
    "/",
    "/visionMission",
    // "/newsletter"
  ].includes(location.pathname);
  /**
   * Valores extraídos del contexto `ScreenContext`, que proporcionan información sobre la pantalla.
   * `isMobile` es un valor booleano que indica si la vista actual corresponde a un dispositivo móvil.
   * `dimensionHeight` es la altura de la ventana del navegador.
   * @type {{isMobile: boolean, dimensionHeight: number}} Un objeto con las propiedades `isMobile` y `dimensionHeight`.
   */
  const { isMobile, isDesktop, dimensionWidth } = useContext(ScreenContext);
  const style = isMobile ? { paddingLeft: location ? 120 : 0 } : {};
  const Dimension = dimensionWidth < 1270;
  return (
    <AppBar
      component="nav"
      position="fixed"
      sx={{ backgroundColor: locationes ? "#162E84" : "#FFF" }}
    >
      <Toolbar disableGutters>
        <Grid container width="100%">
          <Grid size={design.Grid1} />
          <Grid size={design.Grid1} sx={design.Align}>
            <IconButton edge="start" onClick={handleHome}>
              {locationes ? (
                <ImageLoader
                  src="https://centromedicomedam.com/IMG/centromedicoMEDAM/Icono_Centro_Medico_Medam_Blanco.png"
                  alt="Icono_Centro_Medico_Medam_Blanco"
                  width={45}
                  height={45}
                />
              ) : (
                <div style={style}>
                  <ImageLoader
                    src="https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Negro_del_centro-medico_MEDAM.png"
                    alt="Icono_Centro_Medico_Medam_Blanco"
                    width={170}
                    height={45}
                  />
                </div>
              )}
            </IconButton>
          </Grid>
          <Grid container size={design.Grid8} sx={design.Align}>
            {!Dimension &&
              menuItems.map((doc, index) => {
                const Local = location.pathname === doc.path;
                const handlenavigation = () => navigate(doc.path);
                return (
                  <CustomText
                    key={index}
                    variant="subtitle1"
                    color={locationes ? "#FFFFFF" : "#2349D0"}
                    text={doc.name}
                    fontFamily="Plus Jakarta Sans"
                    sx={{
                      borderBottom: locationes
                        ? `2px solid ${Local ? "#FFF" : "transparent"}`
                        : `2px solid ${Local ? "#2349D0" : "transparent"}`,
                      "&:hover": {
                        borderBottom: locationes
                          ? `2px solid ${!Local ? "#FFF" : "transparent"}`
                          : `2px solid ${!Local ? "#2349D0" : "transparent"}`,
                      },
                      ...design.Text,
                    }}
                    onClick={handlenavigation}
                  >
                    {doc.name}
                  </CustomText>
                );
              })}
          </Grid>

          <Grid size={design.Grid1} sx={design.Align}>
            <MenuRedirect
              locationes={locationes}
              isMobile={isMobile}
              isDesktop={isDesktop}
            />
          </Grid>
          <Grid size={design.Grid1} />
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;

const design = {
  Align: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
  Text: {
    marginLeft: 2,
    marginRight: 2,
  },
  Grid1: { xs: 1, md: 1, xl: 1 },
  Grid8: { xs: 8, md: 8, xl: 8 },
};

const menuItems = [
  { name: "Inicio", path: "/" },
  { name: "Servicios", path: "/services" },
  { name: "Directorio de médicos", path: "/medicalDirectory" },
  // { name: "Pre-ingreso", path: "/preRegistration" },
  { name: "¿Cómo llegar?", path: "/location" },
];
